const productMediaGallery = document.querySelector(".product media-gallery");

window.addEventListener("DOMContentLoaded", (ev) => {
  if (productMediaGallery) {
    refreshProductMediaGalleryButtons(productMediaGallery);
  
    window.addEventListener("click", (ev) => {
      const prevButton = ev.target.closest(".slider-button--prev"),
            nextButton = ev.target.closest(".slider-button--next");
  
      if (prevButton || nextButton) {
        const container = ev.target.closest(".product media-gallery").querySelector(".thumbnail-list");
  
        if (prevButton) {
          container.scrollTop -= 300;
        } else if (nextButton) {
          container.scrollTop += 300;
        }
        refreshProductMediaGalleryButtons(productMediaGallery);
        
        setTimeout(() => {
          refreshProductMediaGalleryButtons(productMediaGallery);
        }, 500);
      }

      if (ev.target.closest(".thumbnail-list__item")) {
        refreshProductMediaGalleryButtons(productMediaGallery);
        
        setTimeout(() => {
          refreshProductMediaGalleryButtons(productMediaGallery);
        }, 500);
      }
      
    });
  }
});

function refreshProductMediaGalleryButtons(mediaGallery) {
  const sliderButtons = mediaGallery.querySelectorAll(".slider-button");

  for (const sliderButton of sliderButtons) {
    sliderButton.removeAttribute("disabled");
  }

  const container = mediaGallery.querySelector(".thumbnail-list"),
        prevButton = mediaGallery.querySelector(".slider-button--prev"),
        nextButton = mediaGallery.querySelector(".slider-button--next");
  
  prevButton.setAttribute("disabled", container.scrollTop == 0);
  nextButton.setAttribute("disabled", container.scrollTop == container.offsetHeight);
  
}

function refreshScrollBarWidth() {
  const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
  document.querySelector(':root').style.setProperty('--scrollbar-width', `${scrollBarWidth}px`);
}

function addScrollbarPadding() {
  const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
  document.documentElement.style.paddingRight = `${scrollBarWidth}px`;

  const pageBackground = document.querySelector(".page-background");
  if (pageBackground)
    pageBackground.style.right = `${scrollBarWidth}px`;
  refreshScrollBarWidth();
}

function removeScrollbarPadding() {
  document.documentElement.style.paddingRight = null;
  
  const pageBackground = document.querySelector(".page-background");
  if (pageBackground)
    pageBackground.style.right = null;
  refreshScrollBarWidth();
}

window.addEventListener("resize", (ev) => {
  requestAnimationFrame(() => {
    refreshScrollBarWidth();
  });
});
refreshScrollBarWidth();